const enum ApiEndpointNames {
  GATES = "gates",
  EMERGENCY_STOP = "emergency_stop",
  EMERGENCY_EVACUATE = "emergency_evacuate",
}

export default ApiEndpointNames;